export function createGoogleMapsLink(address) {
  var formattedAddress = address.replace(/\s+/g, ' ').trim();
  formattedAddress = formattedAddress.split(' ').join('+');
  var googleMapsURL = 'https://www.google.com/maps/search/' + formattedAddress;

  return googleMapsURL;
}
